/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

export enum AllowedClientTypesEnumValues {
    ssh = 'ssh',
    cli = 'cli',
    https = 'https',
    snmp = 'snmp',
}

export interface IAllowedClientsConfig {
    areAnyValuesAllowed: boolean,
    allowedValues: IAllowedValue[],
}

export interface IAllowedValue {
    value?: string,
    isGroupRef: boolean,
}
